import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';
import {AuthService} from "./core/auth/auth.service";
import {WebsocketService} from "./shared/services/websocket.service";

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: true,
    imports: [RouterOutlet],
})
export class AppComponent {
    /**
     * Constructor
     */
    constructor(
        private authService: AuthService,
        private webSocketService: WebsocketService
    ) {

        // Check if the user is already authenticated
        if (this.authService.accessToken) {
            // Connect WebSocket with the current access token
            this.webSocketService.connect(this.authService.accessToken);

            // Subscribe to WebSocket events if user is logged in
            this.authService.subscribeToWebSocketEvents();
        }

    }
}
